import { useState } from 'react';

import { Checkbox, Collapse, FormControlLabel, Typography } from '@mui/material';
import { TCollapseItemProps } from '@modules/admin/AdminTools/Workflows/types';

import { StyledExpand, ListItemButton, ListWrapper, WrapperCollapseItem } from '@styles/Admin-tools/Workflows/WorkflowsStyle';

export const CollapseItem = ({
  selectedStep,
  stepData,
  handleChangeCheckbox,
  defaultSelectedStep,
}: TCollapseItemProps) => {
  const [isExpanded, handleExpanded] = useState<boolean>(false);
  const withExpand = !!stepData.childSteps.length;
  const disabled = defaultSelectedStep === stepData.id || stepData.isDefault;

  const handleListItemButtonClick = (): void => {
    if (withExpand && !disabled) handleExpanded(!isExpanded);
  };

  return (
    <WrapperCollapseItem>
      <ListItemButton disabled={disabled} onClick={handleListItemButtonClick}>
        {withExpand && <StyledExpand isOpen={isExpanded} />}

        <FormControlLabel
          disabled={disabled}
          name={stepData.stepPath}
          label={<Typography whiteSpace="nowrap">{stepData.stepPath}</Typography>}
          control={
            <Checkbox
              checked={selectedStep?.id === stepData.id}
              indeterminate={disabled}
              onChange={(event, checked) => {
                handleChangeCheckbox(checked ? stepData : null);
              }}
            />
          }
        />
      </ListItemButton>

      <Collapse unmountOnExit in={isExpanded} timeout="auto">
        <ListWrapper>
          {stepData.childSteps.map((item) => (
            <CollapseItem
              key={item.id}
              stepData={item}
              handleChangeCheckbox={handleChangeCheckbox}
              selectedStep={selectedStep}
              defaultSelectedStep={defaultSelectedStep}
            />
          ))}
        </ListWrapper>
      </Collapse>
    </WrapperCollapseItem>
  );
};
